import React from 'react'
import styled, { keyframes, css } from 'styled-components'

/**
 * Indicador de carga minimalista y único.
 *
 * Un círculo del tamaño del texto y una etiqueta al lado. Sustituye a los dos
 * que había en las pantallas de búsqueda: LoadingSpinner (bloque grande con
 * mensaje) y SpinnerLoading (HashLoader de 60px). Aquellos siguen existiendo
 * para las pantallas que aún los usan.
 *
 * El círculo se dibuja con currentColor y 1em, así que hereda el color y el
 * tamaño del texto que lo rodea y funciona igual sobre fondo claro u oscuro,
 * sin tener que pasarle un color.
 *
 *   <Spinner />                          en línea, "Cargando..."
 *   <Spinner texto='Cargando más...' />  en línea, otra etiqueta
 *   <Spinner bloque />                   centrado, con aire alrededor
 */

const girar = keyframes`
  to { transform: rotate(360deg); }
`

const Circulo = styled.span`
  display: inline-block;
  flex: none;
  width: 1em;
  height: 1em;
  border: 0.15em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: ${girar} 0.7s linear infinite;

  /* A quien le moleste el movimiento, se le deja girar muy despacio en vez
     de pararlo del todo: sigue comunicando que algo está en curso. */
  @media (prefers-reduced-motion: reduce) {
    animation-duration: 2.5s;
  }
`

const Linea = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.6em;
  font-size: 14px;
  line-height: 1;
  color: inherit;
  opacity: 0.8;
  white-space: nowrap;
`

const aparecer = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`

const Bloque = styled.div`
  display: flex;
  justify-content: center;
  padding: 32px 0;

  /* Con 'both' la opacidad es 0 durante el retardo, así que una carga que se
     resuelve rápido no llega a mostrar nada: se evita el parpadeo sin tener
     que temporizar desde JavaScript. */
  ${(props) =>
    props.$retardado &&
    css`
      animation: ${aparecer} 120ms linear 250ms both;
    `}
`

const Spinner = ({ texto = 'Cargando...', bloque = false, retardado = false }) => {
  const contenido = (
    <Linea role='status' aria-live='polite'>
      <Circulo />
      {texto ? <span>{texto}</span> : null}
    </Linea>
  )

  return bloque ? <Bloque $retardado={retardado}>{contenido}</Bloque> : contenido
}

export default Spinner
